import api from 'api';
import uuid from 'uuid/v1';

const sendContactRequest = (payload, extras) => ({
  type: 'SEND_CONTACT_REQUEST',
  payload,
  extras: { ...extras, uuid: uuid() },
});
const sendContactRequestFulfilled = (payload, extras) => ({ type: 'SEND_CONTACT_FULFILLED', payload, extras });
const sendContactRequestRejected = (payload, extras) => ({ type: 'SEND_CONTACT_REJECTED', payload, extras });
const sendContactRequestCancelled = (payload, extras) => ({ type: 'SEND_CONTACT_CANCELLED', payload, extras });
const sendContactRequestRequest = (payload, extras) =>
  api.resources.contact.sendContactRequest(
    { params: payload.params, query: payload.query, body: JSON.stringify(payload.values) },
    extras,
  );

export {
  sendContactRequest,
  sendContactRequestFulfilled,
  sendContactRequestRejected,
  sendContactRequestRequest,
  sendContactRequestCancelled,
};
